import {
    Home, Code, Store, FileText, Package, Users, Shield, CreditCard, UserPlus
} from 'lucide-react';

// Single source of truth for the developer sidebar AND for mapping a route
// back to the menu it belongs to, so permission checks stay in sync with
// what's shown in the sidebar.
export const developerMenuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: Home, exact: true },
    { path: '/dashboard/apps', label: 'My Apps', icon: Package, exact: false },
    { path: '/dashboard/settings/api-security', label: 'API Security', icon: Shield, exact: false },
    { path: '/dashboard/submit-app', label: 'Submit App', icon: FileText, exact: false },
    { path: '/', label: 'Marketplace', icon: Store, exact: true },
    { path: '/dashboard/billing', label: 'Billing', icon: CreditCard, exact: false },
    { path: '/api-docs', label: 'API Docs', icon: Code, exact: true },
    { path: '/dashboard/users', label: 'Users', icon: Users, exact: false },
    { path: '/dashboard/invite-users', label: 'Invite Users', icon: UserPlus, exact: false },
];

// Menu items that only make sense for a "developer_software_company" account
// (they belong to a company and can manage its members) - every other
// professional role (dentist, hygienist, dental_professional) never has a
// company_id, so these must stay hidden and unreachable for them.
export const companyOnlyMenuLabels = new Set(['Users', 'Invite Users']);

// Finds the menu item a given pathname (+ query string) belongs to (exact
// match wins, otherwise the longest non-exact path prefix). Returns null
// when the path isn't tied to any menu (e.g. /dashboard/profile) - such
// paths are left unrestricted by permission checks.
export function findMenuForPath(pathname, search = '') {

    const isEditAppRoute =
        pathname.startsWith('/dashboard/edit-app/') ||
        (pathname === '/dashboard/submit-app' && new URLSearchParams(search).get('mode') === 'edit');
    if (isEditAppRoute) {
        return developerMenuItems.find((item) => item.label === 'My Apps');
    }

    const exactMatch = developerMenuItems.find((item) => item.exact && pathname === item.path);
    if (exactMatch) return exactMatch;

    const prefixMatches = developerMenuItems.filter(
        (item) => !item.exact && (pathname === item.path || pathname.startsWith(item.path + '/'))
    );
    if (prefixMatches.length === 0) return null;

    return prefixMatches.reduce((longest, item) => (
        item.path.length > longest.path.length ? item : longest
    ));
}

// First menu path the given allowed-menu Set grants access to - used as a
// safe redirect target when a sub_user lands on a page they can't access.
export function firstAllowedMenuPath(allowedMenus) {
    const item = developerMenuItems.find((item) => allowedMenus.has(item.label));
    return item ? item.path : null;
}
